export const YusaOvernightCampGetExpensesSelector = ({
  yusaOvernightCampFinancialsData: { YusaOvernightCampGetExpensesList }
}) => YusaOvernightCampGetExpensesList;
export const YusaOvernightCampGetRevenueSelector = ({
  yusaOvernightCampFinancialsData: { YusaOvernightCampRevenueList }
}) => YusaOvernightCampRevenueList;
